import { optionIs, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { RadioSelect } from "../../../../../controls/RadioSelect";
import { FormItem } from "../../../../../controls/FormItem";
import { FieldProps, WithDynamicFormContext } from "../WithDynamicFormContext";
import "./style.scss";
import { useDynamicFormContext } from "../../../DynamicFormContext";

const RadioInputControl = ({
  path,
  label,
  schema,
  data,
  handleChange,
  handleRemove,
  handleBlur,
  required,
  uischema,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const moreInfo = uischema.options?.moreInfo;
  const classes = uischema.options?.classes;
  const { handleMutateChanges } = useDynamicFormContext();

  const removedPaths = uischema.options?.removedPaths;
  const removedPathsCondition = uischema.options?.removedPathsCondition;

  const handleOnSelect = (value: number) => {
    removedPathsCondition === value &&
      removedPaths.forEach((removedPath: string) => {
        handleRemove(removedPath);
      });
  };

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-boolean-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <div className={classes}>
        <RadioSelect
          name={path}
          value={data}
          onBlur={() => handleBlur(path)}
          onChange={(value) => {
            handleChange(path, value);
            handleMutateChanges([{ path, value }]);
            handleOnSelect(value);
          }}
          options={
            uischema.options?.radioOptions as { name: string; value: string }[]
          }
          disabled={disabled}
        />
        {schema.description && (
          <p className="description">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const RadioInputControlEntry = {
  tester: rankWith(10, optionIs("radio", true)),
  renderer: withJsonFormsControlProps(
    WithDynamicFormContext(RadioInputControl)
  ),
};
